/**
 * 关闭当前webview
 * 适用于随手记，卡牛，随管家，其他渠道跳转到H5市场首页
 */
define('util/client-closeView',['util/client-bridge'], function(clientBridge) {
    return function() {
        if (CLIENT_DATA.client === 'ssj') {
            clientBridge.call(clientBridge.uriSuishouji('closeView'));
        } else if (CLIENT_DATA.client === 'kn') {
            clientBridge.call('cardniu://app/webview/close');
        } else if (CLIENT_DATA.client === 'sgj') {
            if (navigator.userAgent.toLowerCase().indexOf('suiguanjia') > -1) {
                clientBridge.call('sgj://app/webview/close');
            } else {
                window.location.href = '/public-vue/sgj/index.html?isBackClose=1#/market/fixin';
            }
        } else {
            window.location.href = '/public-vue/product/index.html';
        }
    };
});

